module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0 -1)\"><rect width=\"17\" height=\"17\" x=\".5\" y=\"1.5\" stroke=\"#7E85AA\" rx=\"1\"/><text fill=\"#7E85AA\" font-family=\"OpenSans, Open Sans\" font-size=\"14\"><tspan x=\"4\" y=\"15\">N</tspan></text></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/n-box.svg
// module id = vNCF
// module chunks = 5